import type { Router } from "vue-router";
import { useQuizStore } from "../stores/quizStore";

export function installQuizGuards(router: Router) {
    router.beforeEach((to) => {
        const quiz = useQuizStore();
        quiz.loadStarted();

        if (to.name === "welcome" || to.name === "start") return true;

        if (!quiz.started) {
            return { name: "welcome" };
        }

        return true;
    });
}
